/**
 * å¬å±çæ¥å£ï¼å°å
 */
export class Address {
  nation: string
  prefecture: string
  city: string
  address: string
  address1: string
  address2: string
  zipCode: string

  constructor() {}
}
